import Action from 'umg-ember-backend/components/record-explorer/for/action';

<template><Action @records={{@model}} @recordType='action' /></template>
